import Confetti from './confetti.png';

export const Images: { [index: string]: string } = {
  Confetti,
};
